import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';
import { UseExhibitionsResult } from '../types';

export const useExhibitions = (params?: {
  page?: number;
  limit?: number;
  status?: 'upcoming' | 'current' | 'past';
  featured?: boolean;
}): UseExhibitionsResult => {
  const {
    data,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['exhibitions', params],
    queryFn: () => apiService.getExhibitions(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return {
    exhibitions: data?.data || [],
    isLoading,
    error: error as Error | null,
    refetch
  };
};